import React, { FC } from 'react';
import { Grid, Paper, Tabs } from '@material-ui/core';
import { useRouteMatch } from 'react-router';
import { LargeTab, PaddedPaper } from 'components';
import { useTranslation } from 'react-i18next';

import * as paths from 'paths';
import * as Links from 'Links';

import PostCTAs from '../components/Sharing/PostCTAs';
import CustomStickers from '../components/Sharing/CustomStickers';

const Sharing: FC = () => {
  const { t } = useTranslation();
  const match = useRouteMatch();

  const isSharing = match.path === paths.adminSettingsSharing;
  const isStickers = match.path === paths.adminSettingsStickers;

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <Paper>
          <Tabs value={match.path}>
            <LargeTab
              component={Links.AdminSettingsSharing}
              label={t('admin:socialPostCTAsHeader')}
              value={paths.adminSettingsSharing}
            />
            <LargeTab
              component={Links.AdminSettingsStickers}
              label={t('admin:shareStickersHeader')}
              value={paths.adminSettingsStickers}
            />
          </Tabs>
          <PaddedPaper padding="25px 40px">
            {isSharing && <PostCTAs />}
            {isStickers && <CustomStickers />}
          </PaddedPaper>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Sharing;
